var globalHelpers = require('../../../../../app/js/globalHelpres');
module.exports = function(posts) {
	'use strict'
	posts.controller('postEditorCtrl',postEditorCtrl);
	postEditorCtrl.$inject=['countCharacters','editorExludeShortcode','parseOptions','refreshtokenService','$window','config','reverseWpautop','$scope','$timeout','jQuery', '$element','getDataService','$compile','$rootScope', '$attrs', 'alertService','postDataService','serverError','offlineError','authtokenService'];
	function postEditorCtrl(countCharacters,editorExludeShortcode,parseOptions,refreshtokenService,$window,config,reverseWpautop,$scope,$timeout,jQuery, $element, getDataService,$compile,$rootScope, $attrs,alertService,postDataService,serverError,offlineError,authtokenService) {   
    var vmeditorP = this;
    vmeditorP.config = config;
    vmeditorP.postObj = $scope.$eval($attrs.objPost);
    vmeditorP.typeData = $scope.$eval($attrs.typeData);
    $scope.windowWidth = window.innerWidth;
    vmeditorP.aiEditorsTools = config.aiEditorsTools;
    vmeditorP.aitoolsEnabled = authtokenService.getAitools();
    vmeditorP.aiEditorToolsEnabled = [];
    vmeditorP.aiEditorsTools.forEach(function(tool) {
      if(vmeditorP.aitoolsEnabled.includes(tool.funcionality)) {
        vmeditorP.aiEditorToolsEnabled.push(tool);
      }
    });
    var editorHeight;
    var editorHeightFunction = function() {
        editorHeight = jQuery('.mce-edit-area').height();
        return  editorHeight;
    }
    function autoResizeHeight(ele) {
      ele.style.height = 'auto';
      ele.style.height = (ele.scrollHeight) + 'px';
    }
    function updateCharacterCount() {
      if (tinymce.activeEditor) {
          var content = tinymce.activeEditor.getContent();
          vmeditorP.postObj.editorCharacterCount = countCharacters(content);
      }
    }
    var modal = angular.element(document.getElementById('modal.html')).html();
    var editorHtml = angular.element(document.getElementById('editor.html')).html();
    var insertTag = angular.element(document.getElementById('insertTag.html')).html();
    var insertPost = angular.element(document.getElementById('insertPost.html')).html();
    var insertEmbedCode = angular.element(document.getElementById('insertEmbedCode.html')).html();
    vmeditorP.selectedPollAction = {value:'default'};
    vmeditorP.selectedTypeVideo = {value:'default'};
    vmeditorP.requiredPoll = false;
    vmeditorP.requiredTnowId = false;
    vmeditorP.requiredVideoType = false;
    vmeditorP.requiredVideoId = false;
    vmeditorP.requiredQuoteText = false;
    vmeditorP.requiredTelegrafVideo = false;
    // vmeditorP.requiredQuestionText = false;
    vmeditorP.quoteModalShow = false;
    vmeditorP.videoModalShow = false;
    vmeditorP.telegrafVideoModalShow = false;
    vmeditorP.editor_preview_visual = true;
    vmeditorP.cancelInsertTagModal = function() {
      vmeditorP.searchTag = null;
      $element.siblings('.editor-insert-tag').remove();
      $rootScope.modalShow = false;
    }
    vmeditorP.cancelInsertPostModal = function() {
      $element.siblings('.editor-insert-post').remove();
      $rootScope.modalShow = false;
    }
    vmeditorP.cancelInsertEmbedCodeModal = function() {
      vmeditorP.embedCode = '';
      $element.siblings('.editor-insert-embedcode').remove();
      $rootScope.modalShow = false;
    }
    vmeditorP.cancelTinymceModal = function() {
      $element.siblings('.tinymce-modal').remove();
      vmeditorP.videoModalShow = false;
      vmeditorP.questionModalShow = true;
      vmeditorP.quoteModalShow = true;
      $rootScope.modalShow = false;
    }
    var minifyHtmlElement = function(content,ele) {
      var elements = content.getElementsByTagName(ele);
      for (var i = 0; i < elements.length; i++) {
        var htmlEl =elements[i].outerHTML;
        jQuery(elements[i]).replaceWith(htmlEl.replace(/^\s+|\r\n|\n|\r|(>)\s+(<)|\s+$/gm, '$1$2').replace(/<br \/>/g, '').replace(/<\/p>/g, '').replace(/<p>/g, ''));
      }
    }
    vmeditorP.pasteText = function(event){
      event.preventDefault();
      var clp = (event.originalEvent || event).clipboardData;
      var text = clp.getData('text/plain')
      text = text.replace(/<p>/gmi, "");
      text = text.replace(/<p ([^>]*)>/gmi, "");
      text = text.replace(/<\/p>/g, "");
      document.execCommand('insertText', false, text);
    } 
    var stripEmptyElement = function(content,ele) {
      var elements = content.getElementsByTagName(ele);
      var isEmpty = function ( el ){
        return !jQuery.trim(el.html())
      }
      for (var i = 0; i < elements.length; i++) {
        
        if (isEmpty(jQuery(elements[i]))) {
          jQuery(elements[i]).remove();
        }
      }
    }
    var  parseOptionsFunc = parseOptions;
    var contentSaveFunction = function() {
      tinyMCE.activeEditor.dom.remove('edit-image');
      tinyMCE.activeEditor.dom.remove('edit-gallery');
      tinyMCE.activeEditor.dom.remove('edit-embed');
      tinyMCE.activeEditor.dom.remove('edit-summary');
      var selectedSummary = tinyMCE.activeEditor.dom.get('selected-summary');
      if(selectedSummary) {
        jQuery(selectedSummary).removeAttr('id')
      }
      // jQuery(tinymce.activeEditor.getBody()).find('a:not([target])').attr({'target': '_blank','rel':'noopener'});
      minifyHtmlElement(tinymce.activeEditor.getBody(),"script")
      // tinyMCE.activeEditor.schema.getNonEmptyElements().svg = {}
      stripEmptyElement(tinymce.activeEditor.getBody(),"a")
      var postContent = tinymce.activeEditor.getContent();
      postContent.replace(/\<captionblock([^\]].*?)>([^\]]*?)\<\/captionblock>/g, function(all, attr, con) {
          var parseOptions = parseOptionsFunc(attr);
          if(parseOptions.signature_url) {
            var signatureUrl = parseOptions.signature_url
          } else {
            var signatureUrl = ''
          }
          if(parseOptions.image_link) { 
            var imageLink = 'image_link="'+parseOptions.image_link+'"'
          } else {
            var imageLink = ''
          }
          if(parseOptions.image_target_blank) {
            var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
          } else {
            var imageTargetBlank = ''
          }
          var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
          postContent = postContent.replace( all,'[caption id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+']'+con+'[/caption]\n\n');
      });
      postContent.replace(/\<galleryblock([^\]].*?)>(.*?)\<\/galleryblock>/g, function(all, attr, con) {
        postContent = postContent.replace( all, con+'\n\n');
      });
      postContent.replace(/\<summaryblock\>(.*?)\<\/summaryblock>/g, function(all, con) {
        postContent = postContent.replace( all, con+'\n\n');
      });
      postContent.replace(/\<embedblock([^\]].*?)>(.*?)\<\/embedblock>/g, function(all, attr, con) {
        var parseOptions = parseOptionsFunc(attr);
        var type = parseOptions.type || parseOptions.src;
        postContent = postContent.replace( all,'[embed type="'+type+'"]'+con+'[/embed]\n\n');
      });
      postContent = reverseWpautop(postContent);
      vmeditorP.postObj.textEditorContent = postContent;
    }
    var aitoolsbar = vmeditorP.aiEditorToolsEnabled.length > 0 ? ' ai |' : '';
    window.editor = tinyMCE;
    vmeditorP.tinymceOptions = {
	    selector: "textarea",
	    format:'raw',
      menubar:false,
      verify_html : true,
      plugins: [
          'lists customLink image anchor',
          'fullscreen',
          'autoresize hr pagebreak paste'
      ],
      skin: false,
      // Prevent HTML entity conversion to preserve &quot; in title attributes
      entity_encoding: 'raw',
      encoding: 'html',
      // Disable automatic entity conversion
      convert_urls: false,
      urlconveter_callback: function(url,node,on_save, name) {
        var url = url;
        if(!url.includes('http') && node.nodeName == 'A' && name=='href') {
          url= 'http://' + url
        }
        return url 
      },
	    // // theme : 'modern',
      toolbar: (vmeditorP.typeData == 'page')? 'formath2 formath3 | bold italic | bullist numlist | hr | link unlink | tolatin | pagebreak | undo redo | fullscreen ':'formath2 formath3 | bold italic | bullist numlist | hr | link unlink | quote | question | recommendedNews | gallery | video | embed | poll | tag |'+aitoolsbar+' tolatin | pagebreak | undo redo | fullscreen ',
      valid_elements : "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
      + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
      + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
      + "name|href|target|title|class|onfocus|onblur|style],strong/b,em/i,strike,u,"
      + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
      + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
      + "-blockquote[*],-table[border=0|cellspacing|cellpadding|width|frame|rules|"
      + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
      + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
      + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
      + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,#div,"
      + "span[*],-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
      + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
      + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
      + "|height|src|*],script[src|type|language|async|defer|charset],map[name],area[shape|coords|href|alt|target],bdo,"
      + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
      + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
      + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
      + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
      + "q[cite],samp,select[disabled|multiple|name|size],small,"
      + "textarea[cols|rows|disabled|name|readonly],tt,var,big,time,iframe[*],-section[*]",
      // valid_elements: '[]',
      // valid_children: '[]',
      extended_valid_elements : "captionblock[id|align|width|height|signature_url|image_link|image_target_blank],+svg[*],+g[*],+path[*],galleryblock[ids|title|safe|span|id],+video[*],+source[*],embedblock[*],summaryblock[*]",
      custom_elements: "captionblock,galleryblock,embedblock,summaryblock",
      valid_children: "+p[strong|a|b|img|i|br|em|script|iframe|blockquote|time],embedblock[blockquote,script,iframe,div],+a[div]", // "+" add valid children 
      content_css: [
          'tinymce/custom-tinymce.css?v=13'
      ],
      body_class: 'custom_class',
      default_link_target: "_blank",
      rel_list: [
        {title: 'DoFollow', value: ''},
        {title: 'NoFollow', value: 'nofollow'},
        {title: 'Sponsored', value: 'sponsored'}
      ],
      target_list:[
        { title: 'Current window', value: '' },
        { title: 'New window', value: '_blank' }
      ],
      forced_root_block : false,
      force_p_newlines : true,
      remove_linebreaks : false,
      relative_urls : false,
      remove_script_host : false,
      indent: false,
      // paste_text_sticky_default: true,
      // force_br_newlines : true,
      remove_trailing_nbsp : false,
      style_formats: [
        {title: 'Heading 2', format: 'h2'},
        {title: 'Heading 3', format: 'h3'},
        {title: 'Heading 4', format: 'h4'},
        {title: 'Heading 5', format: 'h5'},
        {title: 'Heading 6', format: 'h6'},
      ],
      paste_preprocess: function(plugin, args) {
        // Only block actual script/iframe tags or javascript: URLs
        // This pattern looks for opening tags (< or &lt;) followed by script or iframe
        // Or for javascript: protocol in URLs
        var dangerousPattern = /(<script|<iframe|&lt;script|&lt;iframe|script<\/span>|iframe<\/span>|javascript:)/i;
        
        if (dangerousPattern.test(args.content)) {
            // Block the paste and notify the user
            args.content = ''; // Clear the content
            $scope.$apply(function() {
              alertService('danger', 'Oops!', 'Pasting of <script> or <iframe> tags is not allowed! Use embed code button.');
            });
            return;
        }
        
        // Strip all HTML tags except those we have whitelisted
        var whitelist = 'p,strong,i,em,br,a';
        var content = args.content;
        if(args.content.match(/<br>|<br \/>/g)) {
          var content = wpautop(args.content.replace(/<br>|<br \/>/g, "\n"));
        }
        var stripped = jQuery('<div>' + content + '</div>');
        // var brs = stripped.find('br')
        var els = stripped.find('*').not(whitelist);
        for (var i = els.length - 1; i >= 0; i--) {
          var e = els[i];
          jQuery(e).replaceWith(e.innerHTML);
        }
          // Strip all class and id attributes
        stripped.find('*').removeAttr('id').removeAttr('class');
          // Return the clean HTML
        args.content = stripped.html();
      },
      paste_postprocess : function(pl, o) {
          // remove extra line breaks
          o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;/ig, " ");
      },
      init_instance_callback: function (editor) {
        editor.on('SetContent', function (e) {
          editor.setDirty(true);
          editor.fire('change')
        });     
        
        // Custom serializer to preserve HTML entities in title attributes
        editor.serializer.addAttributeFilter('title', function(nodes, name) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            if (node.attr('title')) {
              // Preserve HTML entities in title attributes
              var title = node.attr('title');
              // Ensure quotes are properly encoded as &quot;
              title = title.replace(/"/g, '&quot;');
              node.attr('title', title);
            }
          }
        });
        
        editor.serializer.addNodeFilter('script,style', function(nodes, name) {
          var i = nodes.length, node, value, type;

          function trim(value) {
              /*jshint maxlen:255 */
              /*eslint max-len:0 */
              return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n')
                      .replace(/^[\r\n]*|[\r\n]*$/g, '')
                      .replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '')
                      .replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
          }
          while (i--) {
              node = nodes[i];
              value = node.firstChild ? node.firstChild.value : '';

              if (value.length > 0) {
                  node.firstChild.value = trim(value);
              }
          }
        });
      },
      setup: function(editor) {
        var selection;
        var signature;
        var editImageArray = {};
        var image_id;
        editor.on('PreInit', function() {
          tinyMCE.activeEditor.schema.getNonEmptyElements().svg = {}
        });
        var setCursorAfterCaptionFunction = function(e) {
          var dom = tinymce.activeEditor.dom; 
          var parents = dom.getParents( tinymce.activeEditor.selection.getNode() );
          function setCursorToNewParagraph(){
            var newParagraph = dom.select( 'p#' + uniqueID )[0];
            tinymce.activeEditor.selection.setCursorLocation( newParagraph );
          }
          for( var i=0; i < parents.length; i++ ) {
            var currentNode = parents[i];
            // Insert empty paragraph at the end of the parent of the closest custom tag
            if( currentNode.nodeName == 'CAPTIONBLOCK' || currentNode.nodeName == 'GALLERYBLOCK' || currentNode.nodeName == 'EMBEDBLOCK' || currentNode.nodeName == 'SUMMARYBLOCK') {
                // dom.insertAfter doesn't work reliably
                if(jQuery(currentNode).parent('p').get(0)) {
                  currentNode = jQuery(currentNode).parent('p')
                }
                if(e) {
                  var event = window.event ? window.event : e;
                  if(event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40) {
                    var uniqueID = dom.uniqueId();
                    if(!e.shiftKey) {
                      jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
                      setCursorToNewParagraph() 
                    } else if (event.keyCode == 13 && e.shiftKey) {
                      jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertBefore( currentNode );
                      setCursorToNewParagraph()
                    }
                    e.preventDefault();
                    // Move to the new node
                  }
                } else {
                  var uniqueID = dom.uniqueId();
                  jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
                  
                  // Move to the new node
                  setCursorToNewParagraph()
                }
                // Don't create an extra paragraph
                editor.setDirty(true);
                editor.fire('change')
                break;
            }
          }
        }
        var insertOrUpdateImage = function(imgArray,update) {
          var insertImage={};
          // var insertImages = '';
          for(var i=0; i<imgArray.length;i++) {
            console.log(imgArray[i]);
            insertImage[i] = '<img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>';
            if(imgArray[i].link_to) {
              insertImage[i] = '<a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
              if(imgArray[i].target_blank) {
               insertImage[i] = '<a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
              }
            }
            if(imgArray[i].signature) {
              if(imgArray[i]._id in editImageArray) {
                editImageArray[imgArray[i]._id].signature_image = imgArray[i].signature;
              }
              if(imgArray[i].meta && imgArray[i].meta.signature_url) {
                var signatureUrl = imgArray[i].meta.signature_url
              } else {
                var signatureUrl = ''
              }
              insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</captionblock>';
              if (imgArray[i].link_to) {
                console.log(imgArray[i].link_to)
                insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl +'" image_link="'+imgArray[i].link_to+'"><a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
                if(imgArray[i].target_blank) {
                  insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'" image_link="'+imgArray[i].link_to+'" image_target_blank="true"><a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
                }
              };
            } else {
              insertImage[i] = '<p>'+insertImage[i]+'</p>';
              if(imgArray[i]._id in editImageArray) {
                editImageArray[imgArray[i]._id].signature_image = null;
              }
            }
            if(!update) {
              setCursorAfterCaptionFunction();
            }
            tinymce.activeEditor.execCommand('mceInsertContent', false, insertImage[i]);
          //  insertImages = insertImages.concat(insertImage[i]);
          }
        }
        var addMediaListener = $scope.$on("add-media-to-editor",function(event, data) {
          tinyMCE.activeEditor.dom.remove('edit-image');
          for(var i=0;i<data.insertMediaArray.length;i++) {
  
            if(data.insertMediaArray[i].align === 'undefined' || !data.insertMediaArray[i].align) data.insertMediaArray[i].align = 'alignnone' 
            editImageArray[data.insertMediaArray[i]._id] = {
              id : data.insertMediaArray[i]._id,
              align : data.insertMediaArray[i].align,
              href : data.insertMediaArray[i].href,
              target_blank : data.insertMediaArray[i].target_blank,
              signature_image : data.insertMediaArray[i].signature || null
            }
          }
          insertOrUpdateImage(data.insertMediaArray);
          $timeout(function() {
            tinymce.activeEditor.execCommand('mceAutoResize');
          },100)
        });
        var removeImage = function(parents) {
          for( var i=0; i < parents.length; i++ ) {
            if(parents[i].nodeName == 'IMG') {
              var image = parents[i];
              jQuery(image).remove();
            } else if(parents[i].nodeName =='A') {
              var parentAnchor = parents[i];
              jQuery(parentAnchor).remove();
            }else if(parents[i].nodeName == 'CAPTIONBLOCK') {
              var parentCaption = parents[i];
              jQuery(parentCaption).remove();
            }
          }
        }
        $scope.$on('$destroy', addMediaListener);
        var updateMediaListener = $scope.$on("update-image-editor",function(event, data) {
          var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
          tinyMCE.activeEditor.dom.remove('edit-image');
          setCursorAfterCaptionFunction();
          removeImage(parents)
          if(data.updateImageObject.align === 'undefined' || !data.updateImageObject.align) data.updateImageObject.align = 'alignnone';
          var insertMediaArray = [data.updateImageObject];
          insertOrUpdateImage(insertMediaArray,true);
          var editorContentBody = tinymce.activeEditor.getBody();
          stripEmptyElement(editorContentBody,"p");
          tinyMCE.activeEditor.dom.remove(nodeImage);   
        });
        $scope.$on('$destroy', updateMediaListener);
        var deleteMedia = $scope.$on("delete-media",function(event, data) {
          var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
          tinyMCE.activeEditor.dom.remove('edit-image');
          tinyMCE.activeEditor.dom.remove('selected-image')
          removeImage(parents)
          editor.setDirty(true);
          editor.fire('change')   
        });
        $scope.$on('$destroy', deleteMedia);
        var addSlideshowListener = $scope.$on("insert-gallery",function(event, data) {
          if(data.update) {
            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            setCursorAfterCaptionFunction();
            tinyMCE.activeEditor.dom.remove('selected-gallery');
          }
          var attachments_ids = data.attachments_ids.join();
          var title;
          if(data.gallery_title) {
            title = data.gallery_title
          } else {
            title=''
          }
          var insertslideShowShortcode = '<galleryblock ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '">[gallery ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '"]</galleryblock>';
          setCursorAfterCaptionFunction();
          tinymce.activeEditor.execCommand('mceInsertContent', false, insertslideShowShortcode);
        });
        $scope.$on('$destroy', addSlideshowListener);
        // var addTelegrafTvListener = $scope.$on("insert-telegraftv",function(event, data) {
        //   var postContent = vmeditorP.postObj.textEditorContent;
        //   var validation = true;
        //   postContent.replace(/\[video(.*?)?\](?:([\s\S]*?)(\[\/video\]))?/g, function(all, attr, con) {
        //         var parseOptions = parseOptionsFunc(attr);
        //         if(parseOptions.id == data.videoId) {
        //           validation = false;
        //           alertService('danger','Opps! ', 'This video alredy exist!!!');
        //           return
        //         }
        //   });
        //   if(validation) {
        //     var title=(data.showVideoTitle)? data.title: '';
        //     var align = (data.showVideoTitle)? data.align: '';
        //     var inserVtelegrafVideoShortcode = '[video id="'+data.videoId + '" title="' + title + '" align="' + align + '"]';
        //     setCursorAfterCaptionFunction();
        //     tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+inserVtelegrafVideoShortcode+'</p>');
        //     $timeout(function(){
        //       vmeditorP.postObj.cancelVideoModal()
        //     },0)
        //   }
        // });
        // $scope.$on('$destroy', addTelegrafTvListener);
        var addPollListener = $scope.$on("insert-poll-to-editor",function(event, data) {
          var postContent = vmeditorP.postObj.textEditorContent;
          var validation = true;
          postContent.replace(/\[poll(.*?)?\](?:([\s\S]*?)(\[\/poll\]))?/g, function(all, attr, con) {
                var parseOptions = parseOptionsFunc(attr);
                if(parseOptions.id == data._id) {
                  validation = false;
                  alertService('danger','Opps! ', 'This poll alredy exist!!!');
                  return
                }
          });
          if(validation) {
            if(data.hasOwnProperty('result')) {
              var insertPollShortcode = '[poll id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/poll]';
            } else {
              var insertPollShortcode = '[poll id="'+data._id + '"]'+data._id+'[/poll]';
            }
            setCursorAfterCaptionFunction();
            tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPollShortcode+'</p>');
          }
        });
        $scope.$on('$destroy', addPollListener);
        // var addRatingListener = $scope.$on("insert-rating-to-editor",function(event, data) {
        //   var postContent = vmeditorP.postObj.textEditorContent;
        //   var validation = true;
        //   postContent.replace(/\[rating(.*?)?\](?:([\s\S]*?)(\[\/rating\]))?/g, function(all, attr, con) {
        //         var parseOptions = parseOptionsFunc(attr);
        //         if(parseOptions.id == data._id) {
        //           validation = false;
        //           alertService('danger','Opps! ', 'This rating alredy exist!!!');
        //           return
        //         }
        //   });
        //   if(validation) {
        //     if(data.hasOwnProperty('result')) {
        //       var insertRatingShortcode = '[rating id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/rating]';
        //     } else {
        //       var insertRatingShortcode = '[rating id="'+data._id + '"]'+data._id+'[/rating]';
        //     }
        //     setCursorAfterCaptionFunction();
        //     tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertRatingShortcode+'</p>');
        //   }
        // });
        // $scope.$on('$destroy', addRatingListener);
        // var addBlogListener = $scope.$on("insert-blog-to-editor",function(event, data) {
        //   var postContent = vmeditorP.postObj.textEditorContent;
        //   var validation = true;
        //   postContent.replace(/\[liveblog(.*?)?\](?:([\s\S]*?)(\[\/liveblog\]))?/g, function(all, attr, con) {
        //         var parseOptions = parseOptionsFunc(attr);
        //         if(parseOptions.id == data._id) {
        //           validation = false;
        //           alertService('danger','Opps! ', 'This blog alredy exist!!!');
        //           return
        //         }
        //   });
        //   if(validation) {
        //     var insertBlogShortcode = '[liveblog id="'+data._id + '"]'+data._id+'[/liveblog]';
        //     setCursorAfterCaptionFunction();
        //     tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertBlogShortcode+'</p>');
        //   }
        // });
        // $scope.$on('$destroy', addBlogListener);
        editor.on("init", function() {
          // Add character counter element after the editor
          var counterHtml = '<div class="editor-character-count">Characters: <span ng-class="{\'danger-color\': vmeditorP.postObj.editorCharacterCount < 800}">{{vmeditorP.postObj.editorCharacterCount}}</span></div>';
          jQuery('.mce-edit-area').after($compile(counterHtml)($scope));
          // Initial count
          updateCharacterCount();
          var statusbar_editor = angular.element(document.getElementsByClassName("mce-statusbar"));
          var toolbar_editor = angular.element(document.getElementsByClassName("mce-toolbar-grp"));
          var add_madia_editor = angular.element(document.getElementsByClassName("add-media-editor"));
          var change_preview_wrap = angular.element(document.getElementById("change-preview-wrapper"));
          var editarea_editor = angular.element(document.getElementsByClassName("mce-edit-area"));
          jQuery(editarea_editor).after($compile(editorHtml)($scope));
          var editor_plain_text = document.getElementsByClassName("editor-plain-text")[0];
          jQuery(editor_plain_text).on('input', function () {
            autoResizeHeight(this)
          }); 
          $scope.onScrollAction = function(){
              var width = jQuery('.single-post--left-col').width() -2;
              var offset = jQuery($element).offset();
              var topPos = offset.top;
              var leftPos = offset.left;
              editorHeightFunction();
              //the current height
              var y = window.scrollY || window.pageYOffset;
              //If the current Y is bigger than the element. (you scrolled beyond the element)
              if(y >= topPos - jQuery(change_preview_wrap).outerHeight() && y< topPos + editorHeight - 150){
                jQuery(editarea_editor).css('padding-top',jQuery(toolbar_editor).outerHeight()+jQuery(change_preview_wrap).outerHeight());
                jQuery(toolbar_editor).css({'position':'fixed','top':jQuery(change_preview_wrap).outerHeight(),'left':leftPos, 'z-index':9999,'width':width,'border':'1px solid rgba(0,0,0,0.2)'});
                jQuery(change_preview_wrap).css({'position':'fixed','top':0,'left':leftPos, 'z-index':9999,'width':width +2,'border-bottom':'none'});
                if(!vmeditorP.editor_preview_visual) {
                  jQuery(change_preview_wrap).css({'border-bottom':'1px solid rgba(0,0,0,0.2)'});
                }
                  //do something
              } else {
                jQuery(editarea_editor).css('padding-top',0);
                jQuery(toolbar_editor).css({'position':'static','top':'auto','left':'auto', 'z-index':9999,'width':'auto','border':'none'});
                jQuery(change_preview_wrap).css({'position':'static','width':'100%','border-bottom':'none'});
                if(!vmeditorP.editor_preview_visual) {
                  jQuery(change_preview_wrap).css({'border-bottom': 'none'});
                }
              }
          };
          $scope.onResizeAction = function() {
            if($scope.windowWidth == window.innerWidth) return
            $scope.windowWidth = window.innerWidth
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            $scope.onScrollAction()
          }
          angular.element($window).on('scroll', $scope.onScrollAction);
          angular.element($window).on('resize', $scope.onResizeAction);
          $scope.$on("change-editor",function(event, data) {
            if(data.editor_preview == 'visual') {
                vmeditorP.editor_preview_visual = true;
                jQuery(add_madia_editor).removeClass('hidden');
                jQuery(toolbar_editor).removeClass('hidden');
                jQuery(editarea_editor).removeClass('hidden');
                jQuery(statusbar_editor).removeClass('hidden');
                jQuery(editor_plain_text).addClass('hidden');
                jQuery('.editor-character-count').removeClass('hidden');
                var postContent = vmeditorP.postObj.textEditorContent;
                postContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
                  var parseOptions = parseOptionsFunc(attr);
                  if(parseOptions.signature_url) {
                    var signatureUrl = parseOptions.signature_url
                  } else {
                    var signatureUrl = ''
                  }
                  if(parseOptions.image_link) {
                    var imageLink = 'image_link="'+parseOptions.image_link+'"'
                  } else {
                    var imageLink = ''
                  }
                  if(parseOptions.image_target_blank) {
                    var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
                  } else {
                    var imageTargetBlank = ''
                  }
                  var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
                  postContent = postContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
                });
                postContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
                  var parseOptions = parseOptionsFunc(attr);
                  var title;
                  if(parseOptions.title) {
                    title =parseOptions.title
                  } else {
                    title=''
                  }
                  postContent = postContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'"]</galleryblock>');
                });
                postContent.replace(/\[summary\]([\s\S]*?)\[\/summary\]/g, function(all) {
                  postContent = postContent.replace( all,'<summaryblock>'+all+'</summaryblock>');
                });
                postContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
                  var parseOptions = parseOptionsFunc(attr);
                  var type = parseOptions.type || parseOptions.src;
                  postContent = postContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
                });
                postContent = wpautop(postContent)
                tinyMCE.activeEditor.setContent(postContent);
                contentSaveFunction();
            } else {
                vmeditorP.editor_preview_visual = false;
                stripEmptyElement(tinymce.activeEditor.getBody(),"p");
                contentSaveFunction();
                jQuery(editor_plain_text).removeClass('hidden');
                autoResizeHeight(editor_plain_text);
                jQuery(editarea_editor).addClass('hidden');
                jQuery(statusbar_editor).addClass('hidden');
                jQuery(toolbar_editor).addClass('hidden');
                jQuery(add_madia_editor).addClass('hidden');
                jQuery('.editor-character-count').addClass('hidden');
            }
          });
        });
        //  editor.on('ExecCommand', function (e) {              
        //   console.log(e.command);     
        // })
        // editor.on('Undo', function () {
        //   editor.setDirty(true);
        //   editor.fire('change')
        // });
    
        // editor.on('Redo', function () {
        //   editor.setDirty(true);
        //   editor.fire('change')
        // });
        editor.on('keydown', function( event ) {
          tinyMCE.activeEditor.dom.remove('edit-image');
          tinyMCE.activeEditor.dom.remove('edit-gallery');
          tinyMCE.activeEditor.dom.remove('edit-embed');
          tinyMCE.activeEditor.dom.remove('edit-summary');
          if (event.keyCode === 8) {
            // Get the currently selected node within the editor
            var selectedNode = editor.selection.getNode();
    
            // Check if the selected node is a paragraph
            if (selectedNode && selectedNode.nodeName === 'P') {
                // Check if the cursor is positioned at the beginning of the paragraph
                var selection = editor.selection.getRng();
                if (selection.startOffset === 0 && selection.endOffset === 0) {
                    // Get the previous sibling of the paragraph
                    var prevSibling = selectedNode.previousSibling;
    
                    // Check if the previous sibling is an embedblock
                    if (prevSibling && (prevSibling.nodeName === 'CAPTIONBLOCK' || prevSibling.nodeName === 'EMBEDBLOCK' || prevSibling.nodeName === 'GALLERYBLOCK' || prevSibling.nodeName === 'SUMMARYBLOCK')) {
                        // Prevent the default behavior of the backspace key

                        event.preventDefault();
                        if(!selectedNode.textContent.trim()) {
                          editor.dom.remove(selectedNode);
                        }
                        var range = editor.dom.createRng();
                        range.selectNodeContents(prevSibling);
                        range.collapse(false); // Move to the end
                        editor.selection.setRng(range);
                        return
                    }
                }
            }
          }
          setCursorAfterCaptionFunction(event);
        });
        editor.on("click", function(e) {
          if(vmeditorP.postObj.category =='bbc') {
            jQuery(tinymce.activeEditor.getBody()).addClass('bbc')  
          } else {
            jQuery(tinymce.activeEditor.getBody()).removeClass('bbc')
          }
          selection = tinymce.activeEditor.selection.getNode();
          var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
          var nodeGallery = tinyMCE.activeEditor.dom.get('selected-gallery');
          var nodeEmbed = tinyMCE.activeEditor.dom.get('selected-embed');
          var nodeSummary = tinyMCE.activeEditor.dom.get('selected-summary');
          var ele = e.target.nodeName;
          var classes = jQuery(nodeImage).attr('class');
          if(classes) {
            var classesArray = classes.split(' ');
            if(classesArray.length>1) {
              image_id = classesArray[1].substr(9);
            } else {
              image_id = classesArray[0].substr(9);
            }
          }  
          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
          if(jQuery(e.target).hasClass('mce-i-remove')) {
            tinyMCE.activeEditor.dom.remove('edit-image');
            tinyMCE.activeEditor.dom.remove('selected-image')
            removeImage(parents)
            editor.setDirty(true);
            editor.fire('change')         
          } else if(jQuery(e.target).hasClass('mce-i-remove-gallery')){
            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            tinyMCE.activeEditor.dom.remove('selected-gallery')
            setCursorAfterCaptionFunction();
            editor.setDirty(true);
            editor.fire('change')
          }else if(jQuery(e.target).hasClass('mce-i-remove-summary')){
            console.log('remove summary')
            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-summary')[0] )
            tinyMCE.activeEditor.dom.remove('edit-summary');
            tinyMCE.activeEditor.dom.remove('selected-summary')
            setCursorAfterCaptionFunction();
            editor.setDirty(true);
            editor.fire('change')
          } else if(jQuery(e.target).hasClass('mce-i-editsummary')) {
            tinyMCE.activeEditor.dom.remove('edit-summary');
            if(nodeSummary) {
              jQuery(nodeSummary).removeAttr('id')
            }
            $scope.$apply(function() {
              vmeditorP.postObj.openAiModal('text-summary', true);
            });
          } else if(jQuery(e.target).hasClass('mce-i-editgallery')) {
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            if(!nodeGallery) return
            if(jQuery(nodeGallery).attr('title')) {
              vmeditorP.postObj.gallery_title = jQuery(nodeGallery).attr('title');
            }
            if(jQuery(nodeGallery).attr('safe')) {
              vmeditorP.postObj.slideShowUnsafe = !$scope.$eval(jQuery(nodeGallery).attr('safe'))
            }
            if(jQuery(nodeGallery).attr('ids')) {
              vmeditorP.postObj.galleryUpdateIds = jQuery(nodeGallery).attr('ids'); 
              vmeditorP.postObj.addGallerytoEditor('update');
            } else {
              alertService('danger', 'Opps! ', 'Gallery shortcode is not valid.\nRemove or correct shortcode');
            }
          }else if(jQuery(e.target).hasClass('mce-i-remove-embed')){
            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-embed')[0] )
            tinyMCE.activeEditor.dom.remove('edit-embed');
            setCursorAfterCaptionFunction();
            tinyMCE.activeEditor.dom.remove('selected-embed')
            editor.setDirty(true);
            editor.fire('change')
          } else if(jQuery(e.target).hasClass('mce-i-editimage')) {
            if(vmeditorP.postObj.category == 'bbc') return
            $rootScope.modalShow = true;
            tinyMCE.activeEditor.dom.remove('edit-image');
            for( var i=0; i < parents.length; i++ ) {
                if(parents[i].nodeName =='A') {
                  var parentAnchor = parents[i];
                  var image_href = jQuery(parentAnchor).attr('href');
                  var target_blank = jQuery(parentAnchor).attr('target');
                  if(target_blank) {
                    var targetblank = true;
                  } else {
                    var targetblank = false;
                  }
                  tinyMCE.activeEditor.selection.select(parents[i]);
                } else if(parents[i].nodeName == 'CAPTIONBLOCK') {
                  var parentCaptionblock = parents[i];
                  var image_signature = jQuery(parentCaptionblock).text();
                  var image_align = (!jQuery(parentCaptionblock).attr('align') || jQuery(parentCaptionblock).attr('align') === 'undefined')? 'alignnone': jQuery(parentCaptionblock).attr('align');
                  tinyMCE.activeEditor.selection.select(parents[i]);
                }

            }
            editImageArray[image_id] = {
              id : image_id,
              align : image_align,
              href : image_href,
              target_blank : targetblank,
              signature_image : image_signature
            }
            $rootScope.$broadcast('edit-image', {editImageObj:editImageArray[image_id]});
          } else {
            if(nodeImage) {
              jQuery(nodeImage).removeAttr('id');
            }
            if(nodeGallery) {
              jQuery(nodeGallery).removeAttr('id');
            }
            if(nodeSummary) {
              jQuery(nodeSummary).removeAttr('id');
            }
            if(nodeEmbed) {
              jQuery(nodeEmbed).removeAttr('id');
            }
            tinyMCE.activeEditor.dom.remove('edit-image');
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            tinyMCE.activeEditor.dom.remove('edit-embed');
            tinyMCE.activeEditor.dom.remove('edit-summary');
            if(ele =="IMG") {

              jQuery(e.target).attr('id','selected-image'); 
              var edit_image_content = '<i class="mce-ico mce-i-editimage"></i><i class="mce-ico mce-i-remove"></i>';
              var pos = tinymce.DOM.getPos(e.target);
              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-image','style':'left:'+pos.x+'px;top:'+pos.y+'px;'}, edit_image_content)
            }
            if(ele=="GALLERYBLOCK") {
              jQuery(e.target).attr('id','selected-gallery');
              var galleryWidth = jQuery(e.target).innerWidth(); 
              var edit_gallery_content = '<i class="mce-ico mce-i-editgallery" title="Edit gallery"></i><i class="mce-ico mce-i-remove-gallery" title="Remove gallery"></i>';
              var pos = tinymce.DOM.getPos(e.target);
              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-gallery','style':'left:'+(pos.x + galleryWidth - 45) +'px;top:'+pos.y+'px;'}, edit_gallery_content)
            }
            if(ele=="SUMMARYBLOCK") {
              jQuery(e.target).attr('id','selected-summary');
              var edit_summary_content = '<i class="mce-ico mce-i-editsummary" title="Edit summary"></i><i class="mce-ico mce-i-remove-summary" title="Remove summary"></i>';
              var pos = tinymce.DOM.getPos(e.target);
              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-summary','style':'right:0px;top:'+(pos.y)+'px;'}, edit_summary_content)
            }
            if(ele=="EMBEDBLOCK") {
              jQuery(e.target).attr('id','selected-embed');
              // var embedWidth = jQuery(e.target).innerWidth(); 
              var edit_embed_content = '<i class="mce-ico mce-i-remove-embed" title="Remove embed"></i>';
              var pos = tinymce.DOM.getPos(e.target);
              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-embed','style':'left:'+pos.x +'px;top:'+(pos.y)+'px;'}, edit_embed_content)
            }
          }
         
        });
        editor.on("change", function() {
          contentSaveFunction();    
          updateCharacterCount();
        });
        editor.addButton('formath2', {   
          icon:'h2',
          tooltip : 'Make h2', 
          onclick : function() {
            editor.execCommand('FormatBlock', false, 'h2');
          }
        });
        editor.addButton('formath3', {   
          icon:'h3',
          tooltip : 'Make h3', 
          onclick : function() {
            editor.execCommand('FormatBlock', false, 'h3');
          }
        });
        editor.addButton('tolatin',{
          tooltip:'Convert to latin',
          icon:'latin',
          onclick:function() {
            var content = tinymce.activeEditor.getContent();
            
            content = globalHelpers.specifiedShortcodePlaceholderEditorContent(content, ['embedblock','captionblock']);
            // Convert remaining content to Latin
            var latinContent = globalHelpers.cyrillicToLatin(content);
            // Restore preserved shortcodes
            latinContent = globalHelpers.specifiedShortcodeRestoreEditorContent(latinContent);
            tinymce.activeEditor.setContent(latinContent);
          } 
        });
        if(vmeditorP.typeData == 'post') {
          editor.addButton('poll',{
            tooltip:'Insert poll',
            icon:'poll',
            onclick:function() {
              $timeout(function(){
                $scope.$parent.addPollToEditor()
              },0)
            }
          });
          // editor.addButton('rating',{
          //   tooltip:'Insert rating',
          //   icon:'rating',
          //   onclick:function() {
          //     $timeout(function(){
          //       $scope.$parent.addRatingToEditor()
          //     },0)
          //   }
          // });
          // editor.addButton('blog',{
          //   tooltip:'Insert live blog',
          //   icon:'blog',
          //   onclick:function() {
          //     $timeout(function(){
          //       $scope.$parent.addBlogToEditor()
          //     },0)
          //   }
          // });
          editor.addButton('quote',{
            tooltip:'Insert quote tag',
            icon:'quote',
            onclick:function() {
              vmeditorP.requiredQuoteText = false;
              $rootScope.modalShow = true;
              vmeditorP.videoModalShow = false;
              vmeditorP.quoteModalShow = true;
              vmeditorP.questionModalShow = false;
              vmeditorP.selectedQuoteAlignAction = {value :'left'};
              $timeout(function() {
                $element.after($compile(modal)($scope));
              },10);
              vmeditorP.insertQuote = function() {
                if(vmeditorP.quoteText) {
                  vmeditorP.requiredQuoteText = false;
                    var insertQuoteShortcode = '[quote align="'+vmeditorP.selectedQuoteAlignAction.value +'"]'+vmeditorP.quoteText+'[/quote]';
                    setCursorAfterCaptionFunction();
                    tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertQuoteShortcode+'</p>');
                    $element.siblings('.tinymce-modal').remove();
                    vmeditorP.quoteText = null;
                    vmeditorP.quoteModalShow = false;
                    $rootScope.modalShow = false;
                } else {
                  alertService('danger','Opps! ', 'Quote text is required');
                  vmeditorP.requiredQuoteText = true;
                }
              }
            }
          });
          editor.addButton('tag',{
            tooltip:'Insert tag',
            icon:'tag',
            onclick:function() {
              var edSelection = tinymce.activeEditor.selection;
              if(!edSelection.getContent()) return;
              vmeditorP.searchTag = edSelection.getContent({format : 'text'})
              $timeout(function() {
                $element.after($compile(insertTag)($scope));
                document.getElementById('editor-input-tag').focus()
              },0);
              $rootScope.modalShow = true;
              $scope.$on('editor-select-tag', function(event,data) {
                tinymce.activeEditor.focus();
                edSelection.setContent('<a id="selected-tag" href="'+data.selectedTagObj.tagUrl+'" target="_blank" rel="noopener">' + edSelection.getContent({format : 'text'}) + '</a>');
                tinymce.activeEditor.setContent(tinymce.activeEditor.getContent())
                var edDom = tinymce.activeEditor.dom;
                var selectedTag = edDom.select('a#selected-tag')[0]
                edSelection.select(selectedTag);
                edSelection.collapse(0)
                $timeout(function(){
                  edDom.setAttrib('selected-tag', 'id', '');
                },0)
                $timeout(function(){
                  vmeditorP.cancelInsertTagModal()
                },0)
              });
            }
          });
          editor.addButton('video',{
            tooltip:'Insert video',
            icon:'video',
            onclick:function() {
              vmeditorP.requiredVideoId = false;
              vmeditorP.requiredVideoType = false;
              $rootScope.modalShow = true;
              vmeditorP.videoModalShow = true;
              vmeditorP.quoteModalShow = false;
              vmeditorP.questionModalShow = false;
              vmeditorP.selectedTypeVideo = {value:'default'};
              vmeditorP.videoType = vmeditorP.selectedTypeVideo.value;
              vmeditorP.videoId = null;
              $timeout(function() {
                $element.after($compile(modal)($scope));
              },10);
              vmeditorP.switchTypeVideo = function(type) {
                vmeditorP.videoType = type;
              }
              vmeditorP.insertVideo = function() {
                var validation = true;
                if(vmeditorP.videoType != 'default') {
                  vmeditorP.requiredVideoType = false;
                } else {
                  validation = false;
                  vmeditorP.requiredVideoType = true;
                  alertService('danger','Opps! ', 'Choose video service');
                }
                if(vmeditorP.videoId) {
                  vmeditorP.requiredVideoId = false;
                } else {
                  validation = false;
                  alertService('danger','Opps! ', 'Video ID is required');
                  vmeditorP.requiredVideoId = true;
                }
                if(validation) {
                  $element.siblings('.tinymce-modal').remove();
                  vmeditorP.selectedTypeVideo = {value:'default'};
                  vmeditorP.videoModalShow = false;
                  var insertVideoShortcode = '['+ vmeditorP.videoType +' '+ vmeditorP.videoId +']';
                  setCursorAfterCaptionFunction();
                  tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertVideoShortcode+'</p>');
                  vmeditorP.videoId = null;
                  $rootScope.modalShow = false;
                }
              }
            }
          });
          editor.addButton('question',{
            tooltip:'Add a Question',
            icon:'interview',
            onclick:function() {
              vmeditorP.requiredQuestionText = false;
              $rootScope.modalShow = true;
              vmeditorP.videoModalShow = false;
              vmeditorP.quoteModalShow = false;
              vmeditorP.questionModalShow = true;

              $timeout(function() {
                $element.after($compile(modal)($scope));
              },10);
              vmeditorP.insertQuestion = function() {
                if(vmeditorP.questionText) {
                  vmeditorP.requiredQuestionText = false;
                    setCursorAfterCaptionFunction();
                    tinyMCE.activeEditor.selection.setContent('<ul><li class="intervju">'+vmeditorP.questionText+'</li></ul>');
                    $element.siblings('.tinymce-modal').remove();
                    vmeditorP.questionText  = null;
                    vmeditorP.quoteModalShow = false;
                    $rootScope.modalShow = false;
                } else {
                  vmeditorP.requiredQuestionText = true;
                  alertService('danger','Opps! ', 'Question text is required');
                }
              }
            }
          });
          // editor.addButton('telegrafvideo',{
          //   tooltip:'Insert Telegraf TV Video',
          //   icon:'telegraf-tv',
          //   onclick:function() {
          //     $timeout(function(){
          //       vmeditorP.postObj.insertVideotoEditor();
          //     },0)
          //   }
          // });
          editor.addButton('gallery',{
            tooltip:'Insert gallery',
            icon:'gallery',
            onclick:function() {
              $timeout(function(){
                vmeditorP.postObj.addGallerytoEditor();
              },0)
            }
          });
          editor.addButton('recommendedNews',{
            tooltip:'Insert News',
            icon:'recommended-news',
            onclick:function() {
              $timeout(function() {
                $element.after($compile(insertPost)($scope));
                document.getElementById('search-post').focus()
              },0);
              $rootScope.modalShow = true;
              vmeditorP.addPostFromSearch = function(obj){
                var insertPostShortcode = '[readalso id="'+obj.id +'"][/readalso]';
                setCursorAfterCaptionFunction();
                tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPostShortcode+'</p>');
                $timeout(function(){
                  vmeditorP.cancelInsertPostModal()
                },0)
              }
            }
          });
          editor.addButton('embed',{
            tooltip:'Insert embed code',
            icon:'embed',
            onclick:function() {

              $timeout(function() {
                $element.after($compile(insertEmbedCode)($scope));
                document.getElementById('insert-embedcode').focus()
              },0);
              $rootScope.modalShow = true;
              vmeditorP.insertEmbedCode = function(){
                if(vmeditorP.embedCode) {
                  var type = 'unknown';
                  if(vmeditorP.config.embed) {
                    for (var key in vmeditorP.config.embed) {
                      if(vmeditorP.embedCode.includes(vmeditorP.config.embed[key])) {
                        type = key
                      }
                    }
                  }
                  function replacePWithSpan(html) {
                    // Define a regular expression pattern to match <p> elements
                    var pattern = /<p(\s+[^>]*)?>([\s\S]*?)<\/p>/g;
                
                    // Replace <p> elements with <span> elements
                    var newHtml = html.replace(pattern, function(match, attrs, content) {
                        // Construct the replacement with <span> tag
                        return '<div' + (attrs || '') + '>' + content + '</div>';
                    });
                
                    return newHtml;
                }
                var embed = replacePWithSpan(vmeditorP.embedCode);
                embed = embed.replace(/<br>|<br \/>/g, "");
                // embed = embed.replace(/\[/g, '(').replace(/\]/g, ')');
                var insertEmbedShortcode = '<embedblock type="'+type+'">'+embed+'</embedblock>';
                setCursorAfterCaptionFunction();
                tinymce.activeEditor.execCommand('mceInsertContent', false, insertEmbedShortcode);
                setCursorAfterCaptionFunction();
                $timeout(function(){
                  vmeditorP.embedCode = '';
                  vmeditorP.cancelInsertEmbedCodeModal()
                },0)
                } else {
                  vmeditorP.requiredEmbedCode = true;
                  alertService('danger','Opps! ', 'Embed code is required');
                }
              }
            }
          });
          if(vmeditorP.aiEditorToolsEnabled.length > 0) {
            var menu = [];
            vmeditorP.aiEditorToolsEnabled.forEach(function(tool) {
              menu.push({
                text: tool.name,
                classes: 'ai-menu-item',
                onclick: function(e) {
                  // Prevent event bubbling and default behavior
                  if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                  // Use $timeout to ensure Angular digest cycle
                  $timeout(function() {
                    $scope.$apply(function() { 
                      vmeditorP.postObj.openAiModal(tool.funcionality);
                    });
                  });
                }
              });
            });
            editor.addButton('ai', 
              {
              type: 'menubutton',
              text: 'AI',
              icon: 'ai',
              tooltip: 'AI Tools',
              onPostRender: function() {
                var button = this.getEl();
                if (button) {
                  var buttonContainer = button.parentNode;
                  if (buttonContainer) {
                    buttonContainer.className += ' mce-i-ai-button';
                    // Add touch event handling for the menu items
                    buttonContainer.addEventListener('touchend', function(e) {
                      var menuItem = e.target.closest('.mce-menu-item');
                      if (menuItem) {
                        e.preventDefault();
                        e.stopPropagation();
                        // Find the tool associated with this menu item
                        var toolName = menuItem.textContent.trim();
                        var tool = vmeditorP.aiEditorToolsEnabled.find(function(t) {
                          return t.name === toolName;
                        });
                        if (tool) {
                          $timeout(function() {
                            $scope.$apply(function() {
                              vmeditorP.postObj.openAiModal(tool.funcionality);
                            });
                          });
                        }
                      }
                    }, true);
                  }
                }
              },
              menu: menu
            });
          }
        }
      }    
  	}
    $scope.$on('$destroy', function() {
      angular.element($window).off('scroll', $scope.onScrollAction);
      angular.element($window).off('resize', $scope.onResizeAction);
    });  
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/tinymcePostController.js
// module id = 563
// module chunks = 0